// import React, { useState, useMemo } from "react";
// import { Box, TextField, InputAdornment, IconButton } from "@mui/material";

// import { DataGrid } from "@mui/x-data-grid";

// import SearchIcon from "@mui/icons-material/Search";
// import VisibilityIcon from "@mui/icons-material/Visibility";

// const RiteClientList = ({ clients, onOpen }) => {
//   const [search, setSearch] = useState("");

//   const filtered = useMemo(() => {
//     if (!search) return clients;

//     const q = search.toLowerCase();

//     return clients.filter(
//       (c) =>
//         c.legal_name?.toLowerCase().includes(q) ||
//         c.business_email?.toLowerCase().includes(q),
//     );
//   }, [search, clients]);

//   const columns = [
//     {
//       field: "client_id",
//       headerName: "Client ID",
//       width: 120,
//     },

//     {
//       field: "legal_name",
//       headerName: "Legal Name",
//       flex: 1,
//     },

//     {
//       field: "business_email",
//       headerName: "Business Email",
//       flex: 1.5,
//     },

//     {
//       field: "is_active",
//       headerName: "Active",
//       width: 120,
//       renderCell: (params) => (params.value ? "Yes" : "No"),
//     },

//     {
//       field: "actions",
//       headerName: "Actions",
//       width: 120,
//       renderCell: (params) => (
//         <IconButton onClick={() => onOpen(params.row)}>
//           <VisibilityIcon />
//         </IconButton>
//       ),
//     },
//   ];

//   return (
//     <Box>
//       <TextField
//         placeholder="Search clients..."
//         size="small"
//         value={search}
//         onChange={(e) => setSearch(e.target.value)}
//         sx={{ mb: 2, maxWidth: 400 }}
//         InputProps={{
//           startAdornment: (
//             <InputAdornment position="start">
//               <SearchIcon />
//             </InputAdornment>
//           ),
//         }}
//       />

//       <Box sx={{ height: 500 }}>
//         <DataGrid
//           rows={filtered}
//           columns={columns}
//           getRowId={(r) => r.client_id}
//           pageSizeOptions={[5, 10, 20]}
//           disableRowSelectionOnClick
//         />
//       </Box>
//     </Box>
//   );
// };

// export default RiteClientList;



import React, { useState, useMemo } from "react";
import { Box, TextField, InputAdornment, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";

const RiteClientList = ({ clients = [], onOpen }) => {
  const [search, setSearch] = useState("");

  const handleOpenClient = (client) => {
  try {
    sessionStorage.setItem("activeClientId", client.client_id);
    onOpen(client);
  } catch (err) {
    console.error(err);
    onOpen(client);
  }
};

  const filtered = useMemo(() => {
    if (!search) return clients;

    const q = search.toLowerCase();

    return clients.filter(
      (c) =>
        c.legal_name?.toLowerCase().includes(q) ||
        c.business_email?.toLowerCase().includes(q)
    );
  }, [search, clients]);

  const columns = [
    {
      field: "client_id",
      headerName: "Client ID",
      width: 140,
    },
    {
      field: "legal_name",
      headerName: "Legal Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "business_email",
      headerName: "Business Email",
      flex: 1.5,
      minWidth: 220,
    },
    {
      field: "is_active",
      headerName: "Active",
      width: 120,
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      filterable: false,
     renderCell: (params) => (
    <IconButton onClick={() => handleOpenClient(params.row)}>
      <VisibilityIcon />
    </IconButton>
  ),
    },
  ];

  return (
    <Box>
      <TextField
        placeholder="Search clients..."
        size="small"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 2, maxWidth: 400 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      <Box sx={{ height: 500 }}>
        <DataGrid
          rows={filtered}
          columns={columns}
          getRowId={(row) => row.client_id}
          pageSizeOptions={[5, 10, 20]}
          disableRowSelectionOnClick
        />
      </Box>
    </Box>
  );
};

export default RiteClientList;